import request from "root/js/request";

export const getSharesProductSubjects = async ({
  shares_id,
  cabinet_id,
  category_id__in,
  product_id__in,
  in_shares,
}) => {
  const response = await request({
    url: `/analytics/shares/${shares_id}/products_subject/?cabinet_id=${cabinet_id}`,
    method: "get",
    params: {
      category_id__in,
      product_id__in,
      in_shares,
    },
  });
  return response;
};
